<template>
  <div>
    <GlobalTable
      :title="title + ' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="3">
              <CInput
                label="Name"
                invalid-feedback="Name should be filled"
                required
                v-model="$v.productGroupForm.name.$model"
                :is-valid="!$v.productGroupForm.name.$invalid"
              />
            </CCol>
            <CCol sm="3">
              <CInput
                label="Ordering"
                type="number"
                invalid-feedback="Ordering be filled"
                required
                v-model="$v.productGroupForm.ordering.$model"
                :is-valid="!$v.productGroupForm.ordering.$invalid"
              />
            </CCol>
          </CRow>
          <CRow form class="form-group">
            <CCol sm="3">
              <label>As Shortcut menu </label><br />
              <CInputRadioGroup
                class="col-sm-9"
                :options="options"
                :custom="true"
                :checked="productGroupForm.shortcut"
                :inline="true"
                @update:checked="
                  (option) => (productGroupForm.shortcut = option)
                "
              />
              <div v-if="$v.productGroupForm.shortcut.$invalid" class="invalid-feedback-custom">
                Shortcut button should be filled.
              </div>
            </CCol>
            <CCol sm="3">
              <label>Installment</label><br />
              <CInputRadioGroup
                class="col-sm-9"
                :options="options"
                :custom="true"
                :checked="productGroupForm.flag"
                :inline="true"
                @update:checked="(option) => (productGroupForm.flag = option)"
              />
              <div v-if="$v.productGroupForm.flag.$invalid" class="invalid-feedback-custom">
                Installment condition should be filled.
              </div>
            </CCol>
            <CCol sm="3">
              <label>Show This Button</label><br />
              <CInputRadioGroup
                class="col-sm-9"
                :options="options"
                :custom="true"
                :checked="productGroupForm.show"
                :inline="true"
                @update:checked="(option) => (productGroupForm.show = option)"
              />
              <div v-if="$v.productGroupForm.show.$invalid" class="invalid-feedback-custom">
                Button show should be filled.
              </div>
            </CCol>
            <CCol sm="3">
              <CInputFile
                label="Icon"
                accept="image/*"
                invalid-feedback="Icon should be filled"
                required
                :is-valid="!$v.productGroupForm.icon.$invalid"
                @change="onFileChange"
              />
              <CCard v-if="productGroupForm.icon !== null && isEdit" class="width-100">
                <CImg :src="productGroupForm.icon" :thumbnail="true" />
              </CCard>
            </CCol>
          </CRow>

          <CRow>
            <CCol sm="6">
              <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.productGroupForm.description.$model"
                :is-valid="!$v.productGroupForm.description.$invalid"
              />
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.productGroupForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "../../../templates/Loading";

export default {
  name: "ProductGroup",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Product Group",
      fields: [
        { key: "name", label: "Nama Status", sorter: true },
        { key: "description", label: "Description", sorter: true },
        //{ key: "icon", label: "Icon", sorter: true },
        { key: "shortcut_name", label: "Shortcut", sorter: true },
        { key: "installment_name", label: "Installment", sorter: true },
        { key: "show_name", label: "Show", sorter: true },
        { key: "ordering", label: "Ordering", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      items: [],
      productGroupForm: tableInterfaces.product_group,
      isLoading: false,
      addButton: false,
      isEdit: false,
      checkedRadioOption: null,
      checkedRadioOptionShow: null,
      checkedRadioOptionShortcut: null,
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    };
  },
  validations: {
    productGroupForm: {
      name: { required },
      description: { required },
      shortcut: { required },
      ordering: { required },
      icon: { required },
      flag: { required },
      show: { required }
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getProductGroup();
    },
    getProductGroup: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/product_group/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.productGroupForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.product_group) {
        tableInterfaces.product_group[i] = null;
      }
      this.productGroupForm = tableInterfaces.product_group;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/product_group/edit", this.productGroupForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/master/product_group/add", this.productGroupForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
    onFileChange(e) {
      this.createImage(e[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        this.productGroupForm.icon = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
